module.exports = __webpack_public_path__ + "static/media/doctor-male.d2fad762.svg";